module.exports = __webpack_public_path__ + "static/img/close_about.183182e.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/close_about.svg
// module id = lj9d
// module chunks = 3